import {
  InboundNotificationChangesResponse,
  InboundNotificationListResponse,
  InboundNotificationUnreadCountResponse,
} from '@shared/core/inbound-sms'
import { makeRequest } from 'src/helpers/request'

const baseUrl = `${import.meta.env.VITE_API_URL}/inbound-notifications`

export const inboundNotificationsService = {
  getChanges(since: string) {
    return makeRequest<InboundNotificationChangesResponse>(
      `${baseUrl}/changes?since=${encodeURIComponent(since)}&scope=dashboard`,
      'GET',
    )
  },
  list(page = 0, limit = 20) {
    return makeRequest<InboundNotificationListResponse>(`${baseUrl}?page=${page}&limit=${limit}&scope=dashboard`, 'GET')
  },
  markRead(id: string) {
    return makeRequest(`${baseUrl}/${id}/read`, 'PATCH')
  },
  markUnread(id: string) {
    return makeRequest(`${baseUrl}/${id}/unread`, 'PATCH')
  },
  markAllRead() {
    return makeRequest(`${baseUrl}/read-all`, 'PATCH')
  },
  bulkRead(eventId: string) {
    return makeRequest(`${baseUrl}/bulk-read`, 'PATCH', { eventId })
  },
  unreadCount() {
    return makeRequest<InboundNotificationUnreadCountResponse>(`${baseUrl}/unread-count?scope=dashboard`, 'GET')
  },
}
